import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm, change } from 'redux-form'
import { push } from 'react-router-redux';
import Hashids from 'hashids';

import { 
  tryToAddMember, 
  tryToFetchMembersByTeam
} from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'
import Checkbox from '../Checkbox/Checkbox.js'
import CustomSelect from '../CustomSelect/CustomSelect.js'

const pf_config = require('../../pf_config.json');

const hashids = new Hashids('k100p');

class TeamSettingsAddMemberForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      email: props.memberManager.addMemberForm.lastSubmit.email || "",
      roles: [
        {
          label: "Member",
          value: "member"
        },
        {
          label: "Admin",
          value: "admin"
        },
      ],
      admin_only: false
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount(){
    const { dispatch, memberManager } = this.props;
    if(!memberManager.tryingToFetchMembersByTeam){
      dispatch(tryToFetchMembersByTeam({
        id: this.props.id
      }));
    }
  }


  handleSubmit(e){
    if(e) e.preventDefault();

    const { dispatch, team } = this.props;

    dispatch(tryToAddMember({
      team_id: this.props.id,
      role: this.state.role,
      invite_sent_to: this.state.email,
      admin_only: this.state.admin_only

    }))

    this.setState({
      email: ""
    });
  }

  render(){
    const { dispatch, team, user, memberManager } = this.props; 
    const state = this.state;



    if(!team.cache[this.props.id] || memberManager.tryingToFetchMembersByTeam || !memberManager.cache[this.props.id]) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    let currentMembers = memberManager.cache[this.props.id];

    let thisTeam = team.cache[this.props.id];

    let seatsThatCount = memberManager.cache[this.props.id].filter(m => !m.admin_only).length;
    let emptyseats = thisTeam.seats - seatsThatCount;

    let canSubmit = state.email != "" && team.cache[this.props.id].isFirm && emptyseats > 0;

    return (
      <div>
        {
          !team.cache[this.props.id].isFirm &&
          <p className="div-warning">
            In order to add a member, please migrate to Pattycake for Firms.
          </p>
        }
        {
          emptyseats <= 0 &&
          <div class="div-info-text-large-pad">
            <p>
              <strong>There are zero seats available on your current license.</strong>
            </p>
            <p>
              In order to invite more members, you'll first need to increase the number of available seats on your license by visiting the <Link to={"/settings/firm/" + hashids.encode(thisTeam.id) + '/billing' }>Billing Portal</Link>, clicking "Update plan" and setting your desired quantity.
            </p>
          </div>
        }

        <form onSubmit={(e)=> {
          e.preventDefault();
          if(canSubmit) this.handleSubmit();
        }}>

          <CustomField 
            type="text"
            regex="email"
            name="email"
            placeholder="member@example.com"
            label="Email Address"
            onChange={(v) => { this.setState({email: v}); }}
            required={true}
            serverErrors={memberManager.addMemberForm.errors.email}
            disabled={memberManager.tryingToAddMember || !team.cache[this.props.id].isFirm || emptyseats === 0}
            autoFocus={true}
            clientValidation={(v)=>{
              
              if(!v) v = "";

              if(v.toLowerCase() === user.email.toLowerCase){
                return "You can't send yourself an invite."
              }

              for(var i in currentMembers){
                if(currentMembers[i].invite_sent_to.length > 4){
                  if(currentMembers[i].invite_sent_to.toLowerCase() === v.toLowerCase()){
                    return "You've already invited someone with that email address.";
                  }
                }

                if(currentMembers[i].user){
                  if(currentMembers[i].user.email.toLowerCase() === v.toLowerCase()){
                    return "There is already someone on your team with that email address.";
                  }
                }
              }

            }}
          />

          <div className="large-margin-bottom">
            <CustomSelect
              name="Role"
              label="Role"
              options={this.state.roles}
              value={this.state.role}
              onChange={(v)=>{ 
                this.setState({role: v});
              }}
              placeholder="What privileges should this member have?"
              disabled={memberManager.tryingToAddMember || !team.cache[this.props.id].isFirm || emptyseats === 0}
              description={
                this.state.role === "member" ? <span>Can access, create, and copy patterns.</span> : this.state.role === "admin" ? <span>In addition to member priviliges - admins can make changes to the team's billing information, edit member access, change settings, and make changes to (including deletion) to the firm and its patterns.</span> : ""
              }
              />
          </div>

          {
            this.state.role === "admin" &&
            <div className="flex-split small-padding">
              <p className="text-thin-line-height">
                <small>
                  <strong>Admin-Only</strong>: This individual only needs access to settings and does not require a license.<br/>This cannot be changed without removing and reinviting this user.
                </small>
              </p>
              <p className="text-large-switch">
                <Checkbox large={true} switch={true} value={this.state.admin_only} onToggle={(v) => { this.setState({admin_only: v}) }}/>
              </p>
            </div>
          }

          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={!canSubmit} 
              thinking={memberManager.tryingToAddMember} 
              successful={memberManager.successfullyAddedMember}
              failed={memberManager.failedToAddMember}
              color="success" 
              display="Send Invite" 
            />
          </div>
        </form>
        {
          (thisTeam.isFirm) &&
          <div>
            <hr/>
            <p>You are currently using <strong>{seatsThatCount}</strong> out of <strong>{thisTeam.seats}</strong> seats on your current license.</p>
            <p>To add more seats, visit the <Link to={"/settings/firm/" + hashids.encode(thisTeam.id) + '/billing' }>Billing Portal</Link> and update your plan to the desired quantity.</p>
          </div>
        }
      </div>
    )
  }
}


TeamSettingsAddMemberForm = reduxForm({
  form: 'TeamSettingsAddMemberForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(TeamSettingsAddMemberForm)

TeamSettingsAddMemberForm = connect((state, ownProps) => {
  const { team, user, memberManager } = state;

  var t =  team.cache[ownProps.id];

  var initialValues = {
    emails: ''
  };
  
  return {
    team,
    user,
    memberManager,
    initialValues
  }
})(TeamSettingsAddMemberForm);

export default TeamSettingsAddMemberForm;


// WEBPACK FOOTER //
// ./src/components/TeamSettingsAddMemberForm/TeamSettingsAddMemberForm.js